<template>
    <AisSearchBox
        ref="search"
        v-slot="{ refine }"
        :placeholder="t('placeholder')"
        submit-title="string"
        reset-title="string"
        class="search-box"
    >
        <div class="search-box__form">
            <!-- eslint-disable -->
            <label class="hidden" for="search">Search</label>
            <!-- eslint-enable -->
            <div class="search-box__cell">
                <input
                    id="search"
                    v-model="value"
                    class="search-box__input"
                    :class="(value && value.length > 0) ? 'active' : ''"
                    type="search"
                    :placeholder="t('placeholder')"
                    autocomplete="off"
                    title="Search"
                    @keyup.enter="refine(value), trackSearch(value)"
                >
                <button
                    v-if="value && value.length > 0"
                    class="search-box__reset"
                    :title="t('reset-search')"
                    type="reset"
                    @click="refine(''), setValue('')"
                >
                    <sf-icon
                        class="search-box__clear-icon"
                        icon="cross"
                    />
                </button>
            </div>
            <button
                class="search-box__submit"
                :class="(value && value.length > 0) ? 'active' : ''"
                @click="refine(value), trackSearch(value)"
            >
                <span class="search-box__submit-text">
                    {{ t('submit') }}
                </span>
                <sf-icon
                    class="search-box__submit-icon"
                    icon="search"
                />
            </button>
        </div>
    </AisSearchBox>
</template>

<script>
import SfIcon from '~/patterns/atoms/icon/icon.vue';
import { useTagmanager } from '@digitalnatives/composables/useTagmanager';

import {
    AisSearchBox
} from 'vue-instantsearch/vue3/es/index.js';

export default {
    components: {
        SfIcon,
        AisSearchBox
    },

    props: {
        query: {
            type: String,
            default: null
        }
    },

    setup() {
        const { push } = useTagmanager();
        const { t } = useI18n({
            useScope: 'local'
        });

        return { push, t };
    },

    data() {
        return {
            value: ''
        };
    },

    watch: {
        value() {
            // Reset search when there is no input
            if (this.value && this.value.length === 0) {
                this.$refs.search.state.refine('');
            }
        },

        query() {
            this.value = this.query;
        }
    },
    methods: {
        setValue(value) {
            this.value = value;
        },
        trackSearch(value) {
            this.push({
                event: 'search',
                searchValue: value
            });
        }
    }
};
</script>

<style lang="less" src="./search-box.less"></style>

<i18n lang="json">
{
    "nl": {
        "placeholder": "zoekterm",
        "submit": "zoek",
        "reset-search": "zoekopdracht wissen"
    },
    "en": {
        "placeholder": "search term",
        "submit": "search",
        "reset-search": "clear search"
    }
}
</i18n>
